import createAssetStr from './createAssetStr';

const createAssetSrc = (name: string, folder: string, ext = 'svg') => {
  return `/assets/${folder}/${createAssetStr(name)}.${ext}`;
};

export default createAssetSrc;
